<script setup lang="ts">
import SupplierInvoiceTable from '@/components/invoices/SupplierInvoiceTable.vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>
<template>
  <h1 class="is-size-4 mb-4">{{ t('invoices.title') }}</h1>
  <SupplierInvoiceTable></SupplierInvoiceTable>
</template>
